import { useRouter } from 'next/router';
import AllBlogPageTemplate from './template';
import { Blog } from '../../../types/schema';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { additionalLinkTags, breadcrumbTitle, SEO } from '../../../utils/SEO';

export type AllBlogPageComponentProps = {
  posts: Blog[];
  language: string;
  pageSize: number;
  page: number;
  setPage: (page: number) => void;
  metaTitle: string;
  metaDescription: string;
  metaImage: string;
  hideAppMastersTitle: boolean;
  bannerImg: string;
};

const AllBlogPageComponent: React.FC<AllBlogPageComponentProps> = (props) => {
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || 'http://locahost:3000/';
  const router = useRouter();
  const isEn = props.language === 'en';

  const description = isEn
    ? 'App Masters Blog, with articles about technologies we like to use, work methodologies and so on.'
    : 'Blog da App Masters, com posts escritos pelos colaboradores sobre diversos assuntos ligados a tecnologia, o trabalho e algo mais.';

  const itemListElements = [
    {
      position: 1,
      name: 'App Masters',
      item: `${siteUrl}${router.locale}`,
    },
    {
      position: 2,
      name: breadcrumbTitle(props.metaTitle || 'Blog', isEn, props.hideAppMastersTitle),
      item: `${siteUrl}${router.locale}/blog`,
    },
  ];

  return (
    <>
      <NextSeo
        {...SEO({
          pathname: router.asPath,
          locale: router.locale as string,
          title: props.metaTitle as string,
          defaultTitle: {
            enTitle: 'Blog',
            ptTitle: 'Blog',
          },
          description: (props.metaDescription || description) as string,
          image: props.metaImage as string,
          hideAppMastersTitle: props.hideAppMastersTitle as boolean,
        })}
        additionalLinkTags={additionalLinkTags(['blog', 'blog'])}
      />
      <BreadcrumbJsonLd itemListElements={itemListElements} />
      {/* <Head>
        {Object.entries(alternateURLs).map(([language, url]) => (
          <link key={language} rel="alternate" hrefLang={language} href={url} />
        ))}

        <title>{props.metaTitle}</title>
        <meta name="description" content={props.metaDescription} />

        <meta
          property="og:url"
          content={siteUrl + router.locale + router.asPath}
        />
        <meta
          property="og:title"
          content={props.metaTitle || "Blog | App Masters"}
        />
        <meta property="og:description" content={props.metaDescription} />
        <meta
          name="twitter:title"
          content={props.metaTitle || "Blog | App Masters"}
        />
        <meta name="twitter:description" content={props.metaDescription} />

        <meta property="og:image" content={props.metaImage} />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="800" />
        <meta property="og:image:height" content="600" />

        <script type="application/ld+json">
          {`
            {
              "@context":"https://schema.org",
              "@type":"BreadcrumbList",
              "name":"Posts",
              "itemListElement": ${JSON.stringify(
                props.posts.map((post, i) => ({
                  "@type": "ListItem",
                  position: i + 1,
                  item: {
                    "@id": post.slug,
                    url: `${siteUrl}${props.language}/blog/${post.slug}/`,
                    name: post.title,
                    description: post.description,
                  },
                }))
              )}
            }
        `}
        </script>
      </Head> */}
      <AllBlogPageTemplate
        sortedPosts={props.posts}
        language={props.language}
        pageSize={props.pageSize}
        page={props.page}
        setPage={props.setPage}
        bannerImg={props.bannerImg}
      />
    </>
  );
};

export default AllBlogPageComponent;
